import { Alert, Box, Snackbar } from '@mui/material';
import { styled } from '@mui/material/styles';

interface NotificationItem {
  id: string;
  message: string;
  type: 'success' | 'error';
}

interface AppNotificationsProps {
  notifications: NotificationItem[];
  onDismiss: (id: string) => void;
}

const NotificationAlert = styled(Alert)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    minWidth: 320,
  },
}));

export function AppNotifications({
  notifications,
  onDismiss,
}: AppNotificationsProps) {
  return (
    <Box aria-live="polite" aria-atomic="true">
      {notifications.map((notification) => (
        <Snackbar
          key={notification.id}
          open
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          onClose={(_, reason) => {
            if (reason === 'clickaway') {
              return;
            }
            onDismiss(notification.id);
          }}
        >
          <NotificationAlert
            severity={notification.type === 'error' ? 'error' : 'success'}
            variant="filled"
            onClose={() => onDismiss(notification.id)}
          >
            {notification.message}
          </NotificationAlert>
        </Snackbar>
      ))}
    </Box>
  );
}
